<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  steps: string[]
  currentStep: number
  progressPercentage: number
}>()

const { t } = useI18n()
</script>

<template>
  <div class="progress-section mb-6">
    <h3 class="text-h6 mb-3">{{ t('home.creatingShop') }}</h3>

    <v-progress-linear
      :model-value="progressPercentage"
      height="8"
      rounded
      color="primary"
      class="mb-4"
    />

    <div class="steps-list">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step-item d-flex align-center mb-2"
        :class="{
          'step-active': currentStep === index + 1,
          'step-completed': currentStep > index + 1,
          'step-pending': currentStep < index + 1,
        }"
      >
        <v-icon
          :icon="
            currentStep > index + 1
              ? 'mdi-check-circle'
              : currentStep === index + 1
              ? 'mdi-loading mdi-spin'
              : 'mdi-circle-outline'
          "
          :color="
            currentStep > index + 1
              ? 'success'
              : currentStep === index + 1
              ? 'primary'
              : 'grey'
          "
          class="me-3"
        />
        <span
          :class="{
            'text-primary font-weight-medium': currentStep === index + 1,
            'text-success': currentStep > index + 1,
            'text-medium-emphasis': currentStep < index + 1,
          }"
        >
          {{ step }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.progress-section {
  .step-item {
    transition: all 0.3s ease;

    &.step-active {
      transform: scale(1.02);
    }
  }
}
</style>


